module.exports = __webpack_public_path__ + "img/Tier Zero_basic.901bb40d.svg";